import React, { useEffect, useRef } from 'react';
import WebViewer from '@pdftron/pdfjs-express-viewer';
import ConfigurationService from 'services/ConfigurationService';
import AnalyticsService from 'services/AnalyticsService';
import { ContentType, EventType } from 'model/enums';
import printJS from 'print-js';
import ContentService from 'services/ContentService';
import BaseAnalyticsData from 'model/BaseAnalyticsData';

interface PdfViewerProps {
    licenseKey: string;
    docUrl: string;
    analyticsData: BaseAnalyticsData | null;
}

const inlineStyles = {
    container: {
        height: '1000px',
    },
};

function PdfViewer(props: PdfViewerProps) {
    const viewer = useRef(null);

    useEffect(() => {
        WebViewer(
            {
                licenseKey: props.licenseKey,
            },
            viewer.current,
        ).then((instance) => {
            const jwt = ConfigurationService.retrieveSessionJwt();
            const bearer = 'Bearer ' + jwt;
            const customHeaders = Object();
            customHeaders['Authorization'] = bearer;
            instance.UI.loadDocument(props.docUrl, { customHeaders: customHeaders });

            // Disable the original button in the overflow menu
            instance.UI.disableElements(['printButton']);
            instance.UI.disableElements(['searchButton']);
            instance.UI.disableElements(['selectToolButton']);
            instance.UI.disableElements(['panToolButton']);

            // Create our own button
            instance.UI.setHeaderItems((header) => {
                header.getHeader('default').push({
                    img: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><defs><style>.cls-1{fill:#abb0c4;}</style></defs><title>icon - header - print - line</title><path class="cls-1" d="M20,6H18V2H6V6H4A2,2,0,0,0,2,8v9a2,2,0,0,0,2,2H6v3H18V19h2a2,2,0,0,0,2-2V8A2,2,0,0,0,20,6ZM8,4h8V6H8Zm8,16H8V16h8Zm4-3H18V14H6v3H4V8H20Zm-4-7h2v2H16Zm-3,0h2v2H13Z"></path></svg>',
                    index: -1,
                    type: 'actionButton',
                    element: 'printButton',
                    onClick: async () => {
                        var base64 = await ContentService.getBase64Pdf(
                            props.docUrl + '&base64=true',
                        );
                        printJS({
                            printable: base64,
                            type: 'pdf',
                            base64: true,
                        });
                        AnalyticsService.recordEventType(
                            props.analyticsData,
                            EventType.Print,
                            ContentType.Document,
                        );
                    },
                });
            });
        });
    });

    return (
        <div className="MyComponent">
            <div className="webviewer" style={inlineStyles.container} ref={viewer}></div>
        </div>
    );
}

export default PdfViewer;
